import { createFileRoute } from "@tanstack/react-router";
import { AdminSubmissionsPage } from "@/projects/admin/pages/SubmissionsPage";

export const Route = createFileRoute("/admin/submissions")({
  head: () => ({ meta: [{ title: "Video Submissions — Admin" }] }),
  component: AdminSubmissionsPage,
});
